import {
    VIEW_PROJECT_ASSETS_DOWNLOAD, REQUEST_PROJECT_ASSETS_DOWNLOAD,
    FAIL_PROJECT_ASSETS_DOWNLOAD, CANCEL_PROJECT_ASSETS_DOWNLOAD,
} from "../constant/ActionType";

const emptyPagination = { current_page: 1, last_page: 1, per_page: 10, total: 0 };
export const initialProjectAssetsState = {
    data: [], masterData: null, pagination: emptyPagination,
    error: false, errorMessage: "", loading: false, requestId: null,
};

// Rows and pagination must come from the same response. Never retain earlier totals.
export function normalizeProjectAssets(payload) {
    const nested = payload?.data;
    const paginator = nested && !Array.isArray(nested) && Array.isArray(nested.data) ? nested :
        payload?.pagination || (Array.isArray(nested) && payload.current_page !== undefined ? payload : null);
    const items = paginator && paginator === nested ? nested.data : nested;
    if (!paginator || !Array.isArray(items)) throw new Error("The asset API did not return server pagination metadata.");
    const pagination = Object.fromEntries(["current_page", "per_page", "total", "last_page"].map((key) => [key, Number(paginator[key])]));
    const { current_page: current, per_page: size, total, last_page: last } = pagination;
    if (!Object.values(pagination).every(Number.isInteger) || current < 1 || size < 1 || total < 0 || last < 1 ||
        last !== Math.max(1, Math.ceil(total / size)) || (total > 0 && current > last) ||
        items.length > size || (total === 0 && items.length > 0) || (total > 0 && items.length === 0)) {
        throw new Error("The asset API returned inconsistent pagination metadata. Please retry or contact support.");
    }
    const rest = Object.fromEntries(Object.entries(paginator).filter(([key]) => !["data", "current_page", "per_page", "total", "last_page"].includes(key)));
    return {
        data: items,
        masterData: paginator === nested && Object.keys(rest).length ? rest : null,
        pagination: total === 0 ? { ...pagination, current_page: 1, last_page: 1 } : pagination,
    };
}

export default function ProjectAssetsDownload_reducer(state = initialProjectAssetsState, action) {
    if (action.type === REQUEST_PROJECT_ASSETS_DOWNLOAD) {
        return {
            ...initialProjectAssetsState, requestId: action.requestId, loading: true,
            pagination: { ...emptyPagination, current_page: action.page, per_page: action.perPage },
        };
    }
    if (![VIEW_PROJECT_ASSETS_DOWNLOAD, FAIL_PROJECT_ASSETS_DOWNLOAD, CANCEL_PROJECT_ASSETS_DOWNLOAD].includes(action.type)) return state;
    if (action.requestId !== state.requestId) return state;
    const cleared = {
        ...initialProjectAssetsState, requestId: state.requestId,
        pagination: { ...emptyPagination, per_page: state.pagination.per_page },
    };
    if (action.type === CANCEL_PROJECT_ASSETS_DOWNLOAD) return cleared;
    if (action.type === FAIL_PROJECT_ASSETS_DOWNLOAD) return { ...cleared, error: true, errorMessage: action.errorMessage };
    try {
        return { ...cleared, ...normalizeProjectAssets(action.data) };
    } catch (error) {
        return { ...cleared, error: true, errorMessage: error.message };
    }
}
